import { useEffect, useState } from 'react'
import SearchComponent from '../../../../../components/search/SearchComponent'
import Authentication from '../../../../../libs/api/services/Authentication'
import Facility from '../../../../../libs/api/services/Facility'

export default function FacilitySearchComponent({ name, setLocation, defaultValue }) {
  const [facilities, setFacilities] = useState([])
  const [facility, setFacility] = useState(defaultValue ? defaultValue : { id: parseInt(Authentication.getFacility()) })

  const _loadFacilities = async () =>
    setFacilities(await Facility.list())

  useEffect(() => { _loadFacilities() }, [])
  // Remove this effect:
  // useEffect(() => { if (facility) setLocation(facility) }, [facility, setLocation])

  // Only call setLocation when user selects a new facility
  return (
    <SearchComponent
      name={name}
      focusSearch={true}
      defaultValue={facility}
      onSelected={(e) => {
        setFacility(e);
        setLocation(e);
      }}
      details={{
        data: facilities,
        options: {
          returns: 'object',
          reRefKey: 'id',
          template: [{
            refKey: 'facility',
            descr: '',
          }]
        }
      }} />
  )
}
